import script from "./TheSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSelect.vue?vue&type=script&setup=true&lang=js"

import "./TheSelect.vue?vue&type=style&index=0&id=6c949167&lang=scss&scoped=true"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c949167"]])

export default __exports__